import Image from 'next/image';
import Link from 'next/link';

import { licenses } from '@/common/constants/footer/links.constant';

const Licenses = () => {
  const witroCdn = process.env.WITRO_CDN_URL || 'https://cdn.witro.shop';
  return (
    <div className="flex justify-end items-start gap-4 mt-9 md:mt-0">
      {licenses.map((license, index) =>
        license.link ? (
          <Link key={index} href={license.link}>
            <Image
              src={license.icon}
              alt={license.alt}
              className="w-14 h-14 md:h-24.25 md:w-22.5 bg-silver-200 px-2.25 rounded-lg"
              width={80}
              height={80}
            />
          </Link>
        ) : (
          <div key={index}>
            <Image
              src={license.icon}
              alt={license.alt}
              className="w-14 h-14 md:h-24.25 md:w-22.5 bg-silver-200 px-2.25 rounded-lg"
              width={80}
              height={80}
            />
          </div>
        )
      )}
      <Link
        referrerPolicy="origin"
        target="_blank"
        href="https://trustseal.enamad.ir/?id=733449&Code=kjc7yp1c5njSHhnfBSIjm4Obp88vzG0L"
      >
        <Image
          src={`${witroCdn}/static/images/png/e-namad.png`}
          alt="e-namad logo"
          className="w-14 h-14 md:h-24.25 md:w-22.5 bg-silver-200 px-2.25 rounded-lg"
          width={60}
          height={60}
        />
      </Link>
    </div>
  );
};

export default Licenses;
